var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclearrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.625,
    height: 35.62,
    viewBox: "0 0 35.625 35.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "null",
    strokeWidth: 0,
    d: "M337.175,1497.68h0a17.818,17.818,0,0,0-17.813,17.82h0a17.809,17.809,0,0,0,17.813,17.81h0a17.809,17.809,0,0,0,17.813-17.81h0A17.818,17.818,0,0,0,337.175,1497.68Zm5.111,19.46-7.084,7.08a2.22,2.22,0,1,1-3.139-3.14h0l5.588-5.58-5.588-5.59a2.22,2.22,0,1,1,3.139-3.14l7.084,7.09a2.192,2.192,0,0,1,.649,1.64v0.07A2.225,2.225,0,0,1,342.286,1517.14Z",
    transform: "translate(-319.375 -1497.69)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclearrow);
export default __webpack_public_path__ + "static/media/circlearrow.479b68e9b410728e8fccc3ff9703bb2a.svg";
export { ForwardRef as ReactComponent };